import axios from "axios";
import { API_REQUEST, apiSuccess, apiError, apiFailed } from "./apiCoreRedux";
import store from "storage.js";
import { setIsLoggedIn } from "Redux/DashboardVariables";
import { checkValidLogin } from "HelperFiles/DashboardHelper";

const apiCoreMiddleware =
  ({ dispatch, getState }) =>
    (next) =>
      (action) => {
        next(action);

        if (!action.type.includes(API_REQUEST)) return;

        const { url, method, data, actionType, meta, responseType, abortControllerArrRef } =
          action.payload;

        if (!url.includes('login') && !checkValidLogin()) {
          dispatch(setIsLoggedIn(false));
          dispatch(
            apiFailed({
              response: null,
              actionType,
              meta,
            })
          );
          return;
        }

        const dataOrParams = ["GET"].includes(method) ? "params" : "data";
        const contentType =
          url === ":8989/dataset_images" || url === ":8989/model_upload"
            ? "multipart/form-data"
            : "application/json";

        const baseURL =
          process.env.REACT_APP_DORI_APP_SERVER ||
          getState().REACT_APP_DORI_APP_SERVER ||
          store.get("REACT_APP_DORI_APP_SERVER");

        const controller = new AbortController();
        const signal = controller.signal;

        if (abortControllerArrRef && abortControllerArrRef.current) {
          const tempControllerArr = [...abortControllerArrRef.current, controller];
          abortControllerArrRef.current = tempControllerArr;
        }

        const reqPaylaod = url.includes('login')
          ? {
            url: encodeURI(baseURL + url),
            method,
            responseType,
            [dataOrParams]: data,
            headers: {
              Accept: "application/json",
              "Content-Type": contentType,
            },
            withCredentials: true,
            signal
          }
          : {
            url: encodeURI(baseURL + url),
            method,
            responseType,
            [dataOrParams]: data,
            headers: {
              Accept: "application/json",
              "Content-Type": contentType,
              Authorization: store.get("authToken"),
            },
            signal
          }

        axios
          .request(reqPaylaod)
          .then(({ data }) => {
            if (data.message) {
              // 'message' comes in data only in case of api failure
              dispatch(
                apiFailed({
                  response: data,
                  actionType,
                  meta,
                })
              );
            } else if (data.status.status === "FAILED") {
              // Old api response
              dispatch(
                apiFailed({
                  response: data,
                  actionType,
                  meta,
                })
              );
            } else if (data.status.state === "FAILED") {
              dispatch(
                apiFailed({
                  response: data,
                  actionType,
                  meta,
                })
              );
            } else {
              dispatch(
                apiSuccess({
                  data,
                  actionType,
                  meta,
                })
              );
            }
          })
          .catch((error) => {
            console.log("Api err: ", error);
            dispatch(
              apiError({
                error,
                actionType,
                meta,
              })
            );
          });
      };

export default apiCoreMiddleware;